import WindowModal from './WindowModal';
import ContentProviderDirect from '../lib/modals/content_providers/ContentProviderDirect';
import MapModel from '../maps/MapModel';
import MapView from '../maps/MapView';
import MapObjectBaloonManager from '../maps/MapObjectBaloonManager';
import $ from 'jquery';

class CampMapModal extends WindowModal {
  constructor(markerData, ajaxUrl) {
    super(
      new ContentProviderDirect(
        '<div class="js-camp-map-container" style="height: 450px;"><div class="js-camp-map-instance" style="height: 100%;"></div></div>',
        {
          marker_data: markerData,
          ajax_url: ajaxUrl,
        },
      ),
    );
    this.mapModel = null;
    this.mapView = null;
    this.mapObjectBallonManager = null;
  }

  initContent(data) {
    this.mapModel = new MapModel(data.marker_data, data.ajax_url);
    this.mapView = new MapView(this.mapModel, {
      container: $('.js-camp-map-container'),
      instance: $('.js-camp-map-instance'),
    });
    this.mapObjectBallonManager = new MapObjectBaloonManager(
      this.mapModel,
      this.mapView,
    );
    window.setTimeout(() => {
      this.mapObjectBallonManager.show(data.marker_data[0]['id']);
      this.mapView.map.setCenter(
        this.mapView.getCenterOffset(this.mapView.map.getCenter(), 0, -100),
      );
    }, 200);
  }

  uninitContent() {
    if (this.mapView !== null) {
      this.mapView.unInit();
      this.mapView = null;
      this.mapModel = null;
      this.mapObjectBallonManager = null;
    }
  }
}

export default CampMapModal;



// WEBPACK FOOTER //
// ./src/js/modals/CampMapModal.js